import React, { Component } from "react";
import { toast, ToastContainer } from "react-toastify";
import LayoutWrapper from "./LayoutWrapper";
import CodeModal from "../dashboard/CodeModal";

export class MyContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      editData: {},
      viewMode: false,
      editMode: false,
      popupfields: {},
      popupdata: {},
      search: {
        limit: 10,
        order_by: "createdAt",
        order_direction: "DESC",
        page: 1,
      },
      data: [],
      rowcount: 0,
    };
    this.modalFields = [
      {
        type: "text",
        name: "code",
        label: "Code",
        customcolspan: "col-12",
        required: true,
      },
    ];
    this.codeModalRef = React.createRef();
  }

  componentDidMount() {
    this.getAllProducts();
  }

  addModalFields() {
    let fields = this.modalFields.reduce((o, n) => ({ ...o, [n.name]: n }), {});
    let formdata = Object.map(fields, (v, k) => "");
    this.setState({
      popupfields: fields,
      popupdata: formdata,
    });
  }
  openCodeModal() {
    this.codeModalRef.current.click();
  }
  closeModal() {
    document.querySelector("#code_modal #bsmodalclose").click();
  }
  getAllProducts(params) {
    this.setState({
      loader: true,
    });

    let payload = {
      ...this.state.search,
    };
    const cleanedPayload = Object.fromEntries(
      Object.entries(payload).filter(([_, value]) => value !== undefined)
    );
    console.log({ params, cleanedPayload });

    this.props.api
      .apiGetAllAccessibleProducts(cleanedPayload)
      .then(({ data, total }) => {
        this.setState({
          data: data,
          rowcount: total,
          loader: false,
        });
      })
      .catch((err) => {
        this.setState({
          loader: false,
        });
      });
  }

  handleSubmit(event, data, form) {
    event.preventDefault();

    this.setState({
      loader: true,
    });

    const resolveList = () => {
      toast.success(`Code added successfully`, {
        autoClose: 3000,
        closeButton: false,
        hideProgressBar: true,
      });
      form.reset();
      this.closeModal();
    };
    let payload = {
      qrcode_id: data?.code,
    };
    this.props.api
      .apiScanQRcode(payload)
      .then(resolveList)
      .then(() => {
        this.setState({
          loader: false,
        });
      })
      .catch((error) => {
        this.setState({
          loader: false,
        });
      });
  }
  render() {
    let { navigate } = this.props;
    let { loader, data, editData, viewMode, editMode, popupfields, popupdata } =
      this.state;
    return (
      <>
        {loader && (
          <div className="loader-container">
            <div className="spinner"></div>
          </div>
        )}
        <LayoutWrapper title="My Content" back="">
          <ToastContainer position="top-right" />
          <div
            className="content_banner_card mb-4 cursor-pointer"
            onClick={() => {
              document.querySelector('[data-bs-target="#code_modal"]').click();
            }}
          >
            <img src={imagepaths.starBoximg} alt="starBoximg" />
            <div className="content">
              <p>
                Click here to <span>'Enter Code'</span> to activate purchased
                content
              </p>
            </div>
            <a
              href="#"
              ref={this.codeModalRef}
              data-bs-toggle="modal"
              data-bs-target="#code_modal"
              onClick={(...args) => this.addModalFields(...args)}
            ></a>
          </div>
          <div className="category_card_container bg-transparent">
            <div className="card-body">
              {data &&
                data.map((item) => {
                  let { package_id } = item;
                  let { thumbnail_file, package_name, package_description } =
                    item?.package;
                  return (
                    <div
                      className="category_card cursor-pointer"
                      onClick={(...args) =>
                        navigate(
                          `/mycontent/sessions?packageId=${package_id}&packageName=${package_name}`
                        )
                      }
                    >
                      <div className="img_block">
                        <img
                          src={thumbnail_file?.url}
                          className="img-fluid"
                          alt="image"
                        />
                      </div>
                      <div className="content">
                        <h3 className="title">{package_name}</h3>
                        {/* <p className="desc">{package_description}</p> */}
                      </div>
                    </div>
                  );
                })}
            </div>

            {data?.length == 0 && <div className="empty_layout lms"></div>}
          </div>

          <CodeModal
            id="code_modal"
            title="Enter Code"
            submitText="Submit"
            editdata={editData}
            data={popupdata}
            fields={popupfields}
            disableallfields={viewMode ? true : false}
            submitButton={viewMode ? false : true}
            closeButton={viewMode ? true : false}
            onSubmit={(...args) => this.handleSubmit(...args)}
            onClose={() =>
              this.setState({
                popupdata: {},
                editData: {},
                editMode: false,
                viewMode: false,
              })
            }
          />
        </LayoutWrapper>
      </>
    );
  }
}

export default connect(MyContent);
